export default __webpack_public_path__ + "static/media/courses-page.ca77b156.png";